<template>
  <el-dialog
    :title="$t('chooseService.title')"
    :visible.sync="dialogVisible"
    width="80%"
    :before-close="handleClose"
  >
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card>
          <div slot="header" class="clearfix flex justify-between">
            <el-row :gutter="20">
              <el-col :span="19"></el-col>
              <el-col :span="5">
                <el-input-group>
                  <el-input
                    v-model="chooseServiceInfo.searchName"
                    :placeholder="$t('chooseService.searchPlaceholder')"
                    clearable
                  ></el-input>
                  <el-button 
                    slot="append" 
                    icon="el-icon-search"
                    @click="queryServices()"
                  ></el-button>
                </el-input-group>
              </el-col>
            </el-row>
          </div>
          
          <el-table
            :data="chooseServiceInfo.services"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="name"
              :label="$t('chooseService.serviceName')"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="serviceCode"
              :label="$t('chooseService.serviceCode')"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="method"
              :label="$t('chooseService.method')"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$t('chooseService.operation')"
              width="120"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  @click="chooseService(scope.row)"
                >{{$t('chooseService.select')}}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import { listServices } from '@/api/dev/serviceBindingApi'

export default {
  name: 'ChooseService',
  props: {
    emitChooseService: String,
    emitLoadData: String
  },
  data() {
    return {
      dialogVisible: false,
      chooseServiceInfo: {
        services: [],
        searchName: ''
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.resetSearch()
      this._loadAllServiceInfo(1, 10, '')
    },
    handleClose() {
      this.dialogVisible = false
    },
    resetSearch() {
      this.chooseServiceInfo.searchName = ''
    },
    async _loadAllServiceInfo(page, row, name) {
      try {
        const params = {
          page,
          row,
          name
        }
        const res = await listServices(params)
        this.chooseServiceInfo.services = res.data
      } catch (error) {
        console.error('Failed to load services:', error)
      }
    },
    queryServices() {
      this._loadAllServiceInfo(1, 10, this.chooseServiceInfo.searchName)
    },
    chooseService(service) {
      this.$emit(this.emitChooseService, 'chooseService', service)
      this.$emit(this.emitLoadData, 'listServiceData', {
        serviceId: service.serviceId
      })
      this.handleClose()
    }
  }
}
</script>

<style scoped>
.el-input-group {
  display: flex;
}
</style>